import React from 'react'
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import IconButton from '@material-ui/core/IconButton';
import { RxOrder } from 'openapi';
import RxOrderContainer from "../../containers/RxOrder";
import { CircularProgress } from '@material-ui/core';

interface Props {
    rowData: RxOrder,
    onUpload: (selectedRxOrder: RxOrder) => void,
    isLoading: boolean
}

export default ((props) => {
    const rxOrderContainer = RxOrderContainer.useContainer();

    return (props.isLoading ?
        <CircularProgress size={30} thickness={2} />
        :
        <IconButton color="primary" aria-label="upload" style={{ paddingLeft: '0.7em' }} disabled={(rxOrderContainer.isNewRow || rxOrderContainer.isEditing || rxOrderContainer.isDeleting) && props.rowData.meganetLensRxOrderId !== rxOrderContainer.selectedOrderId ? true : false} onClick={() => props.onUpload(props.rowData)}>
            <CloudUploadIcon style={{ color: 'gray' }} />
        </IconButton>
    )
}) as React.FC<Props>;
